import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import { useAuth } from "../../../core/auth";
import mahiLogo from "../../../assets/images/mahi-download-logo.png";

const BRAND_LOGIN = gql`
  mutation BrandLogin($email: String!, $password: String!) {
    brandLogin(email: $email, password: $password) {
      ok
      error
      token
    }
  }
`;

const BrandLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [formError, setFormError] = useState("");
  const [login, { loading, error: queryError }] = useMutation(BRAND_LOGIN);
  const { loginBrand } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      setFormError("아이디와 비밀번호를 입력해주세요.");
      return;
    }

    try {
      const { data } = await login({
        variables: { email, password },
      });

      if (data?.brandLogin?.ok && data?.brandLogin?.token) {
        localStorage.setItem("brandToken", data.brandLogin.token);
        await loginBrand();
        navigate("/brand-dashboard");
      } else {
        setFormError(
          data?.brandLogin?.error || "아이디 또는 비밀번호가 올바르지 않습니다."
        );
      }
    } catch (err) {
      console.error("Login error:", err);
      setFormError("로그인 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center mb-6">
          <img
            src={mahiLogo}
            alt="마감히어로"
            className="w-16 h-16 object-contain"
          />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          브랜드 로그인
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          브랜드 광고주 계정으로 로그인하세요
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                아이디
              </label>
              <div className="mt-1">
                <input
                  id="email"
                  name="email"
                  type="text"
                  autoComplete="username"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  placeholder="아이디를 입력하세요"
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                비밀번호
              </label>
              <div className="mt-1">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                />
              </div>
            </div>

            {(formError || queryError) && (
              <div className="text-red-500 text-sm text-center">
                {formError || "아이디 또는 비밀번호가 올바르지 않습니다."}
              </div>
            )}

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
              >
                {loading ? "로그인 중..." : "로그인"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BrandLogin;
